<template>
  <div>
    <p>
      {{ user
      }}<span>{{ type == "join" ? "已經進入教室" : "已離開教室" }}</span>
    </p>
    <p>
      {{ user }}
      <span>{{
        type == "join"
          ? "has entered the classroom."
          : "has left the classroom."
      }}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.Vue-Toastification__toast-component-body p {
    margin: 0;
}
</style>
